const carRental = {
  carRental: "Autovermietung", // translated
  carRentals: "Autovermietungen", // translated
  pickUpPoint: "Abholpunkt", // translated
  dropOffPoint: "Ausladepunkt", // translated
  pickUpDate: "Abholdatum", // translated
  dropOffDate: "Abgabedatum", // translated
  pickUp: "Abholen", // translated
  dropOff: "Abgabe", // translated
  edit: "Bearbeiten", // translated
  fuelPolicy: "Kraftstoffpolitik", // translated
  pickUpLocation: "Treffpunkt", // translated
  mileage: "Kilometerstand", // translated
  transmission: "Übertragung", // translated
  airCondition: "Klimaanlage", // translated
  minimumAge: "Mindestalter", // translated
  maximumAge: "Höchstalter", // translated
  providerAddress: "Anbieteradresse", // translated
  providerPhone: "Telefon des Anbieters", // translated
  driverInfo: "Fahrerinfo", // translated
  driversInfo: "Fahrerinfo", // translated
  differentDropOff: "Abgabe an einem anderen Ort", // translated
  maxPassengers: "Max. Passagiere", // translated
  budget: "Budget", // translated
  provider: "Anbieter", // translated
  carModel: "Auto Model", // translated
  numOfDoors: "Anzahl der Türen", // translated
  fuelType: "Treibstoffart", // translated
  driverAge: "Alter des Fahrers", // translated
  workingHours: "Arbeitszeit", // translated
  driverNationality: "Nationalität des Fahrers", // translated
  carRentalRate: "Mietwagenpreis", // translated
  dueNow: "Jetzt fällig", // translated
  duePickUp: "Fällig bei Abholung", // translated
  toViewOfferPDF: "Bitte sehen Sie sich ein PDF-Dokument mit allen Mietbedingungen dieses Angebots an", // translated
  toViewTermsAndCondPDF: "Bitte sehen Sie sich die geltenden Geschäftsbedingungen von CARNECT an", // translated
};


export default carRental;
